import React from 'react';
import Input from '../../../../../Core/Fields/Floating/Input';
import Date from '../../../../../Core/Fields/Floating/Date';
import SelectSearch from '../../../../../Core/Fields/Floating/SelectSearch';
import CheckboxNew from '../../../../../Core/Fields/Floating/CheckboxNew';

const DescriptionTab1 = ({ formData, onFieldChange, extraData }) => {
    console.log(extraData.customerTypes, "customerTypes");
    //   inspection_required_before_purchase : false,
    //     inspection_required_before_delivery : false,
    //     include_item_in_manufacturing : false,
    //     supply_raw_materials_for_purchase : false,
    return (
        <div>

            <div style={{ display: 'flex', width: '100%', gap: '20px', marginTop: '20px' }} >
                <div style={{ width: '30%' }}  >
                    <div className='' style={{ backgroundColor: '#F9F3F5', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                        <span style={{ fontSize: '16px', fontWeight: 700 }}> Description</span>
                        <div >
                            <Input label="Description" style={{ height: "100px" }} value={formData.description} onChange={(e) => onFieldChange('description', e.target.value, "checkbox")} />
                        </div>


                    </div>
                </div>

                <div style={{ width: '70%' }}>
                    <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                        <span style={{ fontSize: '16px', fontWeight: 700 }}> Quality</span>
                        <div style={{ display: 'flex', gap: '15px', width: '100%', marginBottom: '10px' }}>

                            <div style={{ width: '30%' }}>
                                <SelectSearch
                                    label="Quality Inspection Template"
                                    list={extraData.assigned_to}

                                    getOptionLabel={(item) => item.name}
                                    getOptionValue={(item) => item.name}
                                    style={{ height: "30px" }}
                                    value={formData.quality_inspection_template}
                                    onChange={(e) => onFieldChange('quality_inspection_template', e.target.value)}
                                />
                            </div>
                            <div style={{ flex: 1, width: '60%', marginTop: '25px' }}>
                                <div style={{ display: 'flex', width: '100%', gap: '15px' }} >

                                    <CheckboxNew
                                        id="chk1"
                                        label="Inspection Required before Purchase"
                                        labelPosition="right"
                                        checked={formData.inspection_required_before_purchase}
                                        onChange={(e) => onFieldChange('inspection_required_before_purchase', e.target.checked)}
                      
                                    />

                                    <CheckboxNew
                                        id="chk2"
                                        label="Inspection Required before Delivery"
                                        labelPosition="right"
                                        checked={formData.inspection_required_before_delivery}
                                        onChange={(e) => onFieldChange('inspection_required_before_delivery', e.target.checked)}


                                    />


                                </div>


                            </div>




                        </div>

                        <div>
                            <span style={{ fontSize: '16px', fontWeight: 700 }}> Manufacturing</span>
                            <div style={{ display: 'flex', width: '100%', gap: '15px', marginTop: '10px' }} >
                                <CheckboxNew
                                    id="chk1"
                                    label="Inspection Required before Purchase"
                                    labelPosition="right"
                                    checked={true}
                                // onChange={(e) => setIsActive(e.target.checked)}

                                />
                                <CheckboxNew
                                    id="chk2"
                                    label="Inspection Required before Delivery"
                                    labelPosition="right"
                                    checked={true}
                                // onChange={(e) => setIsActive(e.target.checked)}

                                />


                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default DescriptionTab1;